import { JsonObject, JsonProperty } from 'json2typescript'
import AdditionalPolicyholder from '../AdditionalPolicyholder'
import QuoteRequest from '../QuoteRequest'
import Property from './Property'

@JsonObject('PropertyQuoteRequest')
export default class PropertyQuoteRequest extends QuoteRequest {
  @JsonProperty('properties', [Property])
  properties: Property[] = []

  @JsonProperty('additionalPolicyholder', AdditionalPolicyholder)
  additionalPolicyholder: AdditionalPolicyholder | null = null

  @JsonProperty('yearsWithNoClaimsBuilding', String, true)
  yearsWithNoClaimsBuilding: string | null = null

  @JsonProperty('yearsWithNoClaimsContents', String, true)
  yearsWithNoClaimsContents: string | null = null
}

@JsonObject('PropertyMTAQuoteRequest')
export class PropertyMTAQuoteRequest extends PropertyQuoteRequest {
  @JsonProperty('reasonForChange', String)
  reasonForChange = ''
}
